import { render } from "./ScreenElement.vue?vue&type=template&id=0b036cf9&scoped=true&ts=true"
import script from "./ScreenElement.vue?vue&type=script&lang=ts"
export * from "./ScreenElement.vue?vue&type=script&lang=ts"

import "./ScreenElement.vue?vue&type=style&index=0&id=0b036cf9&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b036cf9"]])

export default __exports__